import { render, staticRenderFns } from "./NavbarPopupMenu.vue?vue&type=template&id=de63d600&scoped=true&"
import script from "./NavbarPopupMenu.vue?vue&type=script&lang=js&"
export * from "./NavbarPopupMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavbarPopupMenu.vue?vue&type=style&index=0&id=de63d600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de63d600",
  null
  
)

export default component.exports